import { TimeModeType } from '../../constants/Constants';
import { TimeMode } from '../../types/TimeMode';
import { DateTimeFormat } from '../Format';

/**
 * Column cells get the app-wide Local/UTC preference from the table instance:
 * `Table` puts it on `options.meta.timeMode`, so a cell can format a timestamp
 * without its column factory having to take the mode as an argument.
 *
 * Falls back to UTC, which is what the endpoints return, when a cell is rendered
 * by a table that does not set the meta.
 */
export interface TimeModeTableMeta {
  timeMode?: TimeMode;
}

export const tableTimeMode = (table: any): TimeMode => ((table?.options?.meta as TimeModeTableMeta)?.timeMode ?? TimeModeType.Utc) as TimeMode;

export const isUtcTable = (table: any): boolean => tableTimeMode(table) === TimeModeType.Utc;

/** `DateTimeFormat.toStandardDate` for a cell, honouring the table's time mode. */
export const formatCellDate = (table: any, date: any, withoutTime = false) => DateTimeFormat.toStandardDate(date, isUtcTable(table), withoutTime);

/** `DateTimeFormat.toStandardDateWithSeconds` for a cell, honouring the table's time mode. */
export const formatCellDateWithSeconds = (table: any, date: any, withoutTime = false) =>
  DateTimeFormat.toStandardDateWithSeconds(date, isUtcTable(table), withoutTime);

/** `DateTimeFormat.toTimeFromNow` for a cell, honouring the table's time mode. */
export const formatCellTimeFromNow = (table: any, date: any) => DateTimeFormat.toTimeFromNow(date, isUtcTable(table));

/** 'UTC' or 'Local' for the mode the given table is rendering in. */
export const timeModeName = (table: any): string => (isUtcTable(table) ? 'UTC' : 'Local');

export const dateHeader = (label: string) => {
  const header = ({ table }: any) => `${label} (${timeModeName(table)})`;

  header.label = label;

  return header;
};
